import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next'
import { withNamespaces } from 'react-i18next';
import ScheduleWeekSelect from './ScheduleWeekSelect'
import { listSummarySchedule } from '../../actions/schedule/listSchedule';
import { getMonth, formatDate, toDisplayDecimal } from '../../utils';
import { IsEnglish } from '../../utils/language';
import ScheduleDescriptionWeekDay from './ScheduleDescriptionWeekDay'
import ScheduleWeekPrint from './ScheduleWeekPrint'
import TabScheduleDetail from './TabScheduleDetail'
import AppBar from '@material-ui/core/AppBar'
import ScheduleLegend from './ScheduleLegend';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import AttachMoney from '@material-ui/icons/AttachMoney';
import PrintIcon from '@material-ui/icons/Print';
import { faSwatchbook, faPrint } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../../images/KoneK_logo_2.jpg";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { download } from '../../utils/download';
import { isIOS } from '../../utils';
import * as storage from '../../utils/storage';


const useStyles = makeStyles((theme) => ({
    divRoot: {
        margin: '0px 20px',
        overflowY: 'auto',
        fontSize: '14px',
        '& > div:last-child': {
            paddingBottom: '10px'
        }
    },
    divDate: {
        fontWeight: 'bold',
        color: 'var(--color1)',
        borderRadius: '10px',
        marginTop: '10px',
    },
    divInfo: {
        marginTop: '10px',
        borderRadius: '10px',
        boxShadow: '0px 0px 4px 0px',
        paddingBottom: '10px',
        margin: '10px 3px',
        textAlign: 'left !important',
        minHeight: '276px'
    },
    divRow: {
        display: 'table',
        '& > span:first-of-type': {
            float: 'left',
            fontWeight: 'bold'
        },
        '& > span:nth-child(2)': {
            marginLeft: '5px',
            float: 'right',
            fontWeight: 'bold'
        }
    },
    divHour: {
        width: '100%',
        paddingTop: '5px',
        paddingBottom: '5px',
        paddingLeft: '10px',
        paddingRight: '10px',
        borderBottom: '1px solid var(--color9)',
        fontSize: '16px',
        borderTopLeftRadius: '9px',
        borderTopRightRadius: '9px',
        backgroundColor: 'var(--color1)',
        color: 'var(--color2)'
    },
    divLegend: {
        overflow: 'auto',
        '@media (max-width: 600px)': {
            height: '450px'
        },
    },
    divDescriptionPayable: {
        overflow: 'auto',
        padding: '20px',
    },
    h6: {
        '@media (max-width: 600px)': {
            fontSize: '1.20rem'
        },
    },
    appBar: {
        top: 'auto',
        bottom: '56px',
        height: '41px !important',
        boxShadow: '0 9px 20px 0 !important',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    appBarIOS: {
        bottom: '70px',
    },
    appBarLegend: {
        backgroundColor: '#ffffff !important'
    },
    toolBar: {
        minHeight: '35px',
        paddingRight: '5px!important'
    },
    legend: {
        width: '100%',
        textAlign: 'center'
    },
    buttonLegend: {
        '& > span': {
            color: '#333333'
        }
    },
    paymentIcon: {
        '& > span': {
            float: 'right',
            position: 'absolute',
            marginLeft: '30px'
        }
    },
    total: {
        width: '100%',
        position: 'relative',
        top: '0px',
    },
    totalPayablesHours: {
        width: '100%',
        position: 'relative',
        top: '0px',
        cursor: 'pointer'
    },
    totalLabel: {
        fontSize: '11px',
        position: 'relative',
        top: '-4px',
    },
    hidePdf: {
        height: '0px',
        overflow: 'scroll'
    },
    divTabMaster: {
        paddingLeft: '10px',
        paddingRight: '10px'
    },
    divTab: {
        display: 'table',
        width: '100%'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


function ListSchedule(props) {

    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const [data, setData] = React.useState(null);
    const [openLegend, setOpenLegend] = React.useState(false);
    const [isActive, setIsActive] = React.useState(true);
    const [periodPayment, setPeriodPayment] = React.useState(null);
    const [startDatePayment, setStartDatePayment] = React.useState(null);
    const [endDatePayment, setEndDatePayment] = React.useState(null);
    const [openPayment, setOpenPayment] = React.useState(false);
    const [openPayablesHours, setOpenPayablesHours] = React.useState(false);
    const [total, setTotal] = React.useState(0);
    const [totalHoursWorked, setTotalHoursWorked] = React.useState(0);
    const [isiOS, setIsiOS] = React.useState(isIOS());
    const [isDisplayPayablesHours, setIsDisplayPayablesHours] = React.useState(storage.getIsDisplayPayablesHours());
    const [descriptionTotalPayables, setDescriptionTotalPayables] = React.useState('');

    const classes = useStyles();

    useEffect(() => {
        resize();
    }, []);

    useEffect(() => {
        if (props.descriptionTotalHoursPayables !== '') {
            setDescriptionTotalPayables(props.descriptionTotalHoursPayables);
        }
    }, [props.descriptionTotalHoursPayables]);


    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const divWeek = document.querySelector('#divWeek').clientHeight;
            const divMenu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 85;

            const customHeight = height - divWeek - titleBar - divMenu - offSet;

            const element = document.querySelector('#divRoot');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 1000);
    }


    const onChangeDate = (startDate, endDate) => {
        setStartDatePayment(startDate);
        setEndDatePayment(endDate);
        loadSummary(startDate, endDate);
    }

    const loadSummary = (startDate, endDate) => {
        setIsActive(true);

        return new Promise((resolve) => {
            listSummarySchedule(startDate, endDate).then((response) => {
                const list = JSON.parse(response.list);
                setData(list.listSummary);
                calculateTotal(list.listSummary);
                setTotalHoursWorked(list.hoursWorked)
                setIsActive(false);
                resolve();
            });
        });
    }

    const calculateTotal = (list) => {
        let sumDuration = 0;

        list.forEach(item => {
            sumDuration += item.duration;
        })

        setTotal(sumDuration);
    }

    const DivDate = (data) => {
        return (
            data && data.map((obj, index) =>
                <div key={index}>
                    <div className={classes.divDate}>
                        <ScheduleDescriptionWeekDay date={obj.date} /> {!IsEnglish() && (new Date(obj.date)).getDate()} {getMonth(new Date(obj.date), IsEnglish())} {IsEnglish() && (new Date(obj.date)).getDate()}
                        {obj.isPayment &&
                            <IconButton edge="start" className={classes.paymentIcon} color="inherit" onClick={(event) => onOpenPayment(event, obj.periodPayment, obj.startPayment, obj.endPayment)} aria-label="close">
                                <AttachMoney />
                            </IconButton>}
                    </div>
                    <div className={classes.paymentCell}>
                    </div>
                    {DivContent(obj.listDetail, obj.duration)}
                </div>
            )
        );
    }

    const DivContent = (data, duration) => {
        if (data != null) {
            return (
                data.map((obj, index) =>
                    <div className={classes.divInfo} key={index} style={{ borderBottom: `10px solid ${obj.color}` }}>
                        <div className={`${classes.divRow} ${classes.divHour}`}>
                            <span>{formatDate(obj.startDate, 'time')} - {formatDate(obj.endDate, 'time')}</span>
                            <span>{toDisplayDecimal(duration)}</span>
                        </div>

                        <div className={classes.divTabMaster}>
                            <div className={classes.divTab}>
                                <TabScheduleDetail data={obj} />
                            </div>
                        </div>
                    </div>
                )
            );
        }
        return i18next.t('schedule:scheduler.noTimePlanning');
    }

    const handleCloseClick = () => {
        setOpenLegend(false);
    }

    const handleButtonLegend = () => {
        setOpenLegend(true);
    }

    const onOpenPayment = (event, period, startDate, endDate) => {
        event.preventDefault();
        event.stopPropagation();
        setPeriodPayment(period);
        setStartDatePayment(formatDate(startDate, 'date'));
        setEndDatePayment(formatDate(endDate, 'date'));
        setOpenPayment(true);
    }

    const handleOpenPayablesHours = () => {
        setOpenPayablesHours(true);
    }

    const handleClosePayment = () => {
        setOpenPayment(false);
    }

    const handleClosePayablesHours = () => {
        setOpenPayablesHours(false);
    }

    const handlePrintContainer = () => {
        let pdfElement = document.querySelector(".divPdfExport");

        drawDOM(pdfElement, {
            paperSize: "A4",
            margin: "1cm"
        })
            .then((group) => {
                return exportPDF(group);
            })
            .then((dataUri) => {
                const base64 = dataUri.split(";base64,")[1];

                const linkSource = `data:application/octet-stream;base64,${base64}`;
                download(linkSource, `${formatDate(startDatePayment, 'date')}_${formatDate(endDatePayment, 'date')}.pdf`, `application/octet-stream`);
            });
    }

    return (
        <LoadingOverlay
            active={isActive}
            spinner={<BeatLoader />}
            text={i18next.t('schedule:scheduler.loading')}
        >

            <div id={"divWeek"}>
                <ScheduleWeekSelect onChangeDate={onChangeDate} selectedDate={selectedDate} />
            </div>
            <div id={"divRoot"} className={classes.divRoot}>
                {DivDate(data)}
            </div>
            <AppBar position="fixed" className={`${classes.appBar} ${isiOS && classes.appBarIOS}`}>
                <Toolbar className={classes.toolBar}>
                    <IconButton edge="start" color="inherit" onClick={(event) => handlePrintContainer()} aria-label="print">
                        <FontAwesomeIcon icon={faPrint} />
                    </IconButton>

                    <div className={classes.total}>
                        {toDisplayDecimal(total)}
                        <div className={classes.totalLabel}>
                            {i18next.t('schedule:scheduler.totalHour')}
                        </div>
                    </div>

                    {isDisplayPayablesHours && <div onClick={handleOpenPayablesHours} className={classes.totalPayablesHours}>
                        {toDisplayDecimal(totalHoursWorked)}
                        <div className={classes.totalLabel}>
                            {i18next.t('schedule:scheduler.totalHourWorked')}
                        </div>
                    </div>}

                    <IconButton edge="start" color="inherit" onClick={(event) => handleButtonLegend()} aria-label="color">
                        <FontAwesomeIcon icon={faSwatchbook} />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <div className={classes.hidePdf}>
                <div className={'divPdfExport' + ' ' + classes.divPdfExport}>
                    <div className={classes.divLogo}>
                        <div>{formatDate(startDatePayment, 'date')} - {formatDate(endDatePayment, 'date')}</div>
                        <img src={logo} style={{ height: "80px" }} alt="KoneK Mobile" />
                    </div>

                    <ScheduleWeekPrint data={data} />
                </div>
            </div>

            <Dialog open={openLegend} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div>
                    <AppBar position="static" color="default" className={classes.appBarLegend}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.h6}>
                                {i18next.t('schedule:color.colorLegend')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div className={classes.divLegend}>
                    <ScheduleLegend />
                </div>
            </Dialog>

            <Dialog
                open={openPayment}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title" className={classes.titlePayment}>
                    {i18next.t('schedule:scheduler.payDay')}
                    <div className={classes.divButtonClosePayment}>
                        <IconButton edge="start" color="inherit" onClick={handleClosePayment} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {i18next.t('schedule:scheduler.description')} {periodPayment} - {startDatePayment} {i18next.t('schedule:scheduler.to')} {endDatePayment}
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openPayablesHours}
                onClose={handleClosePayablesHours}
                TransitionComponent={Transition}
            >
                <div>
                    <AppBar position="static" color="default" className={classes.appBarLegend}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleClosePayablesHours} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.h6}>
                                {i18next.t('schedule:scheduler.totalHourWorked')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div className={classes.divDescriptionPayable}>
                    <div className={classes.divEntireMessage} dangerouslySetInnerHTML={{ __html: descriptionTotalPayables }} />
                </div>
            </Dialog>
        </LoadingOverlay>
    );
}

export default withNamespaces(['schedule'], { wait: true })(ListSchedule);